module.exports = __webpack_public_path__ + "img/img29.3b689d39.svg";